import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconSubscriptionCalendar: React.FC<IconProps> = ({ width = 16, height = 16 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_85283)">
                <path
                    d="M1.33203 8.0013C1.33203 5.48714 1.33203 4.23007 2.11308 3.44902C2.89413 2.66797 4.15121 2.66797 6.66536 2.66797H9.33203C11.8462 2.66797 13.1033 2.66797 13.8843 3.44902C14.6654 4.23007 14.6654 5.48714 14.6654 8.0013V9.33464C14.6654 11.8488 14.6654 13.1059 13.8843 13.8869C13.1033 14.668 11.8462 14.668 9.33203 14.668H6.66536C4.15121 14.668 2.89413 14.668 2.11308 13.8869C1.33203 13.1059 1.33203 11.8488 1.33203 9.33464V8.0013Z"
                    stroke="#7F7F7F"
                    stroke-width="1.5"
                />
                <path
                    d="M4.66797 2.66797V1.66797"
                    stroke="#7F7F7F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <path
                    d="M11.332 2.66797V1.66797"
                    stroke="#7F7F7F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <path
                    d="M1.66797 6H14.3346"
                    stroke="#7F7F7F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_85283">
                    <rect width="16" height="16" rx="5" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSubscriptionCalendar;
